

import {createSlice} from "@reduxjs/toolkit";

export const contractDrilldownSliceCDPVF = createSlice({
    name: 'contractDrilldownSlcCDPVF',
    initialState: {value: {
            id: null,
            contractDataPointId: null,
            contractDataPointValueId: 11,
            parentFilterId: null,
            previousFilterId: null,
            ordinalNumber: null,
            recordLevel: null,
            dataPointId: null,
            singleValue: null,
            singleValueNumber: null,
            fromValue: null,
            toValue: null,
            status: null,
            hierarchy: null,
            cdpvMockValue: null,
            expressionIndicator: null,
            mockExpression: null,
            mockExpressionTranslation: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null,
            expressionIndicatorOld: null,
            mockExpressionOld: null,
            mockExpressionTranslationOld: null,
            cdpvCount: null,
            dataPointName: null,
            dataType: null,
            displaySingleValue: null,
            displayFromValue: null,
            displayToValue: null,
            cdpDataPointId: null,
            cdpDataPointName: null,
            cdpDataType: null,
            mockOrigin: null,
            cdpvValue: null,
            expression: null,
            expressionTranslation: null,
            expressionDescription: null,
            mockValue: null,
            parentDataPointId: null,
            parentDataPointName: null,
            parentDataType: null,
            parentDisplaySingleValue: null,
            parentDisplayFromValue: null,
            parentDisplayToValue: null,
            cdpvId: null,

        cdpvfGridState: false,
        cdpvfDrawerState: false,
            cdpvfDrawerMode: null}},
    reducers:
{
    changeContractDrilldownCDPVF: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDrilldownCDPVF } = contractDrilldownSliceCDPVF.actions;

export default  contractDrilldownSliceCDPVF.reducer ;
